import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import "@/index.css";
import { AuthProvider, useAuth } from "./context/Auth";
import { DataProvider, ToastProvider, useData } from "./context/Data";
import { Spinner, CookieBar } from "./components/common";
import Shell from "./components/Shell";
import AuthPage from "./pages/AuthPage";
import { VerifyLink, ResetPage } from "./pages/AuthExtra";
import Legal from "./pages/Legal";
import AdminApp from "./admin/AdminApp";
import Inicio from "./views/Inicio";
import Misiones from "./views/Misiones";
import Premios from "./views/Premios";
import Vip from "./views/Vip";
import Actividades from "./views/Actividades";
import Referidos from "./views/Referidos";
import Ranking from "./views/Ranking";
import Estadisticas from "./views/Estadisticas";
import Cartera from "./views/Cartera";
import Retiradas from "./views/Retiradas";
import Ayuda from "./views/Ayuda";
import Perfil from "./views/Perfil";

const VIEWS = { inicio: Inicio, misiones: Misiones, premios: Premios, vip: Vip, actividades: Actividades, referidos: Referidos,
  ranking: Ranking, estadisticas: Estadisticas, cartera: Cartera, retiradas: Retiradas, ayuda: Ayuda, perfil: Perfil };

function PanelView() {
  const { view } = useParams();
  const { d, error } = useData();
  const V = VIEWS[view];
  if (!V) return <Navigate to="/panel/inicio" replace />;
  return (
    <Shell view={view}>
      {!d ? (error ? <div className="notice" data-testid="dashboard-error">{error}</div> : <Spinner />) : <section className="view active" key={view} data-testid={`view-${view}`}><V /></section>}
    </Shell>
  );
}

function Private() {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  if (!user || !user.email_verified) return <Navigate to="/" replace />;
  return <DataProvider><PanelView /></DataProvider>;
}

function Home({ initial }) {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  if (user && user.email_verified) return <Navigate to="/panel/inicio" replace />;
  return <AuthPage initial={initial} />;
}

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home initial="register" />} />
            <Route path="/login" element={<Home initial="login" />} />
            <Route path="/verificar" element={<VerifyLink />} />
            <Route path="/restablecer" element={<ResetPage />} />
            <Route path="/legal/:doc" element={<Legal />} />
            <Route path="/panel/:view" element={<Private />} />
            <Route path="/admin/*" element={<AdminApp />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieBar />
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}
